import { render, staticRenderFns } from "./LayoutSample.vue?vue&type=template&id=7ff84784&"
import script from "./LayoutSample.vue?vue&type=script&lang=ts&"
export * from "./LayoutSample.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports